// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__iCIzd","label":"SetPasswdForm_label__2LyJc"};